import React from "react";
import { Face } from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";
import { Route } from "react-router-dom";

import AttributeEditor from "../components/attribute_field";
import ConfirmationButton from "../components/confirmation_button";
import DefaultTable from "../components/table";
import CharacterTable from "../components/character_table";
import PetTable from "../components/pet_table";
import ProfileCosmeticTable from "../components/profile_cosmetic";
import DynamicSnackbar from "../components/dynamic_snackbar";
import LoadingBackdrop from "../components/loading_backdrop";
import SimpleSelect from "../components/select";
import SimpleSwitch from "../components/switch";
import TabRouter from "../components/tab_router.js";
import issueStateUpdateRequest from "../components/panel_update_helper";

const useStyles = (theme) => ({
  tabs: {
    height: 60,
    paddingTop: 15,
  },
});

class PlayerInfoPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      dynamicSnackbar: {
        open: false,
        severity: null,
        message: null,
        url: null,
      },
      panelHeader: "",
      playerId: null,
      panels: [],
      previousBattlePassTable: {
        headers: [],
        values: [],
      },
      charactersTable: {
        headers: [],
        values: [],
        urls: [],
        unlockStates: [],
        characterIds: [],
      },
      friendsTable: {
        headers: [],
        values: [],
        urls: [],
      },
      petsTable: {
        headers: [],
        values: [],
        urls: [],
        unlockStates: [],
        petIds: [],
      },
      avatarsTable: {
        headers: [],
        values: [],
        urls: [],
        unlockStates: [],
        cosmeticIds: [],
      },
      backgroundsTable: {
        headers: [],
        values: [],
        urls: [],
        unlockStates: [],
        cosmeticIds: [],
      },
      transactionRecordsTable: {
        headers: [],
        values: [],
        urls: [],
      },
      gachaTransactionRecordsTable: {
        headers: [],
        values: [],
        urls: [],
      },
      gachaBannersTable: {
        headers: [],
        values: [],
      },
      pityInfo: [],
    };
  }

  render() {
    const { classes } = this.props;
    return (
      <div className="panel server-panel">
        <LoadingBackdrop open={this.state.loading} />
        <DynamicSnackbar
          open={this.state.dynamicSnackbar.open}
          severity={this.state.dynamicSnackbar.severity}
          message={this.state.dynamicSnackbar.message}
          url={this.state.dynamicSnackbar.url}
          handleClose={() => {
            this.setState({
              dynamicSnackbar: { ...this.state.dynamicSnackbar, open: false },
            });
          }}
        />
        <h1>{this.state.panelHeader}</h1>
        <h5 style={{ color: "grey", margin: 0 }}>{this.state.serverTime}</h5>
        <br />

        <TabRouter
          defaultTab="General"
          defaultPath={"/player/" + this.state.playerId}
          className={classes.tabs}
        >
          <Route
            label="General"
            path={"/player/" + this.state.playerId + "/general"}
          >
            {this.state.panels.map(this.renderAttributePanelSection)}
            <div className="panel-section">
              <p>Previous Battle Passes</p>
              <DefaultTable
                tableKey={this.state.previousBattlePassTable.name}
                tableHeaders={this.state.previousBattlePassTable.headers}
                tableRows={this.state.previousBattlePassTable.values}
              />
            </div>
          </Route>
          <Route
            label="Characters"
            path={"/player/" + this.state.playerId + "/characters"}
          >
            <div className="panel-section">
              <h1>Characters</h1>

              <ConfirmationButton
                onClick={this.unlockAllCharacters}
                title="Unlock All Characters"
                confirmationMessage="Unlocking all characters may cause unintended side-effects"
              >
                Unlock All Characters
              </ConfirmationButton>

              <ConfirmationButton
                onClick={this.unlockAllCharacterSkins}
                title="Unlock All Characters & Available Skins"
                confirmationMessage="Unlocking all character skins may cause unintended side-effects"
              >
                Unlock All Characters & Available Skins
              </ConfirmationButton>

              <CharacterTable
                tableKey={this.state.charactersTable.name}
                tableHeaders={this.state.charactersTable.headers}
                tableRows={this.state.charactersTable.values}
                tableUrls={this.state.charactersTable.urls}
                playerId={this.state.playerId}
                unlockStates={this.state.charactersTable.unlockStates}
                characterIds={this.state.charactersTable.characterIds}
                onCharacterTableChange={this.handleTableChange}
              />
            </div>
          </Route>
          <Route
            label="Friends"
            path={"/player/" + this.state.playerId + "/friends"}
          >
            <div className="panel-section">
              <h1>Friends</h1>
              <DefaultTable
                tableKey={this.state.friendsTable.name}
                tableHeaders={this.state.friendsTable.headers}
                tableRows={this.state.friendsTable.values}
                tableUrls={this.state.friendsTable.urls}
                linkIcon={<Face />}
              />
            </div>
          </Route>
          <Route label="Pets" path={"/player/" + this.state.playerId + "/pets"}>
            <div className="panel-section">
              <h1>Pets</h1>
              <ConfirmationButton
                onClick={this.unlockAllPets}
                title="Unlock All Pets"
                confirmationMessage="Unlock all pets?"
              >
                Unlock All
              </ConfirmationButton>
              <PetTable
                tableKey={this.state.petsTable.name}
                tableHeaders={this.state.petsTable.headers}
                tableRows={this.state.petsTable.values}
                tableUrls={this.state.petsTable.urls}
                playerId={this.state.playerId}
                unlockStates={this.state.petsTable.unlockStates}
                petIds={this.state.petsTable.petIds}
                onTableChange={this.handleTableChange}
              />
            </div>
          </Route>
          <Route
            label="Avatars"
            path={"/player/" + this.state.playerId + "/avatars"}
          >
            <div className="panel-section">
              <h1>Avatars</h1>
              <ProfileCosmeticTable
                tableKey={this.state.avatarsTable.name}
                tableHeaders={this.state.avatarsTable.headers}
                tableRows={this.state.avatarsTable.values}
                tableUrls={this.state.avatarsTable.urls}
                playerId={this.state.playerId}
                unlockStates={this.state.avatarsTable.unlockStates}
                cosmeticIds={this.state.avatarsTable.cosmeticIds}
                onTableChange={this.handleTableChange}
              />
            </div>
          </Route>
          <Route
            label="Backgrounds"
            path={"/player/" + this.state.playerId + "/backgrounds"}
          >
            <div className="panel-section">
              <h1>Backgrounds</h1>
              <ProfileCosmeticTable
                tableKey={this.state.backgroundsTable.name}
                tableHeaders={this.state.backgroundsTable.headers}
                tableRows={this.state.backgroundsTable.values}
                tableUrls={this.state.backgroundsTable.urls}
                playerId={this.state.playerId}
                unlockStates={this.state.backgroundsTable.unlockStates}
                cosmeticIds={this.state.backgroundsTable.cosmeticIds}
                onTableChange={this.handleTableChange}
              />
            </div>
          </Route>
          <Route
            label="Transactions"
            path={"/player/" + this.state.playerId + "/transactions"}
          >
            <div className="panel-section">
              <h1>Transaction Records</h1>
              <DefaultTable
                tableKey={this.state.transactionRecordsTable.name}
                tableHeaders={this.state.transactionRecordsTable.headers}
                tableRows={this.state.transactionRecordsTable.values}
              />
            </div>
          </Route>
          <Route
            label="Gacha"
            path={"/player/" + this.state.playerId + "/gacha"}
          >
            <div className="panel-section">
              <h1>Banners</h1>
              <DefaultTable
                tableKey={this.state.gachaBannersTable.name}
                tableHeaders={this.state.gachaBannersTable.headers}
                tableRows={this.state.gachaBannersTable.values}
              />
            </div>
            {this.state.pityInfo.map(this.renderAttributePanelSection)}
            <div className="panel-section">
              <h1>Transaction Records</h1>
              <DefaultTable
                tableKey={this.state.gachaTransactionRecordsTable.name}
                tableHeaders={this.state.gachaTransactionRecordsTable.headers}
                tableRows={this.state.gachaTransactionRecordsTable.values}
              />
            </div>
          </Route>
        </TabRouter>
      </div>
    );
  }

  renderAttributePanelSection = (panel, i) => {
    return (
      <div className="panel-section" key={"panel-section-" + i}>
        <h1>{panel.sectionName}</h1>
        {panel.attributes.map(this.renderDomElements)}
      </div>
    );
  };

  renderDomElements = (spec) => {
    switch (spec.domElementType) {
      case "INPUT":
        return this.renderInput(spec, "TEXTFIELD");
      case "TEXTAREA":
        return this.renderInput(spec, "TEXTAREA");
      case "SELECT":
        return this.renderSelect(spec);
      case "SWITCH":
        return this.renderSwitch(spec);
      default:
        return;
    }
  };

  renderInput = (spec, altType) => {
    return (
      <AttributeEditor
        key={spec.attributeId + spec.value}
        attributeId={spec.attributeId}
        url={spec.setterUrl}
        label={spec.label}
        value={spec.value}
        type={spec.type}
        editable={spec.editable}
        onEdit={this.handleAttributeEdit}
        altType={altType}
      />
    );
  };

  renderSelect = (spec) => {
    return (
      <SimpleSelect
        key={spec.attributeId}
        value={spec.value}
        name={spec.name}
        label={spec.label}
        url={spec.setterUrl}
        onChange={this.handleAttributeEdit}
        editable={spec.editable}
        listValues={spec.values}
        attributeId={spec.attributeId}
        width={spec.width}
        confirmed={spec.confirmed}
        confirmSpecificStates={spec.confirmSpecificStates}
        updateByOtherFields={spec.updateByOtherFields}
      />
    );
  };

  renderSwitch = (spec) => {
    return (
      <SimpleSwitch
        key={spec.attributeId}
        switchOn={spec.switchOn}
        name={spec.name}
        label={spec.label}
        url={spec.setterUrl}
        onChange={this.handleAttributeEdit}
        editable={spec.editable}
        attributeId={spec.attributeId}
        width={spec.width}
        confirmed={spec.confirmed}
        confirmSpecificStates={spec.confirmSpecificStates}
      />
    );
  };

  async componentDidMount() {
    await issueStateUpdateRequest(
      this,
      "/player_info_panel/get_player_info/" + this.props.match.params.playerID
    );
    await issueStateUpdateRequest(
      this,
      "/player_info_panel/get_transaction_history/" +
        this.props.match.params.playerID
    );
    await issueStateUpdateRequest(
      this,
      "/player_info_panel/get_active_banners_and_pity/" +
        this.props.match.params.playerID
    );
  }

  handleAttributeEdit = async (url, attributeId, newValue) => {
    await issueStateUpdateRequest(
      this,
      url,
      {
        playerId: this.state.playerId,
        attributeId: attributeId,
        value: newValue,
      },
      "post"
    );
  };

  handleTableChange = async () => {
    await issueStateUpdateRequest(
      this,
      "/player_info_panel/get_player_info/" + this.props.match.params.playerID
    );
  };

  unlockAllCharacters = async () => {
    await issueStateUpdateRequest(
      this,
      "/player_info_panel/unlock_all_characters",
      { playerId: this.state.playerId },
      "post"
    );
  };

  unlockAllCharacterSkins = async () => {
    await issueStateUpdateRequest(
      this,
      "/player_info_panel/unlock_all_character_skins",
      { playerId: this.state.playerId },
      "post"
    );
  };

  unlockAllPets = async () => {
    await issueStateUpdateRequest(
      this,
      "/player_info_panel/unlock_all_pets",
      { playerId: this.state.playerId },
      "post"
    );
  };
}

export default withStyles(useStyles)(PlayerInfoPanel);
